export default __webpack_public_path__ + "static/media/trus10.1cedb75d.png";